export default __webpack_public_path__ + "f0bf6a5b20c6259fade22a16c310cf19.svg";